import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <span className="text-background-50 font-bold text-lg leading-none">91</span>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-900">91导航</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              一站式网址导航与资源聚合平台，让您告别繁琐搜索，一键直达所需网站。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/sousuo" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">搜索引擎</Link>
              </li>
              <li>
                <Link to="/category/xinwen" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">新闻资讯</Link>
              </li>
              <li>
                <Link to="/category/gongju" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">实用工具</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/gouwu" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">购物消费</Link>
              </li>
              <li>
                <Link to="/category/shipin" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">视频娱乐</Link>
              </li>
              <li>
                <Link to="/category/xuexi" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">学习教育</Link>
              </li>
              <li>
                <Link to="/category/shejiao" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">社交社区</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">品牌介绍</Link>
              </li>
              <li>
                <a href="mailto:contact@91daohang.com" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer" rel="nofollow">联系我们</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 91导航 All Rights Reserved. 本站为网址导航平台，不存储任何第三方内容。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}